import React, { FC } from 'react';
import { Layout } from 'antd';
import { useParams } from 'react-router-dom';
import { Sidebar } from 'common/components/Sidebar';
import { splitMenuPath } from 'common/helpers/sidebar.helper';
import { ESidebarMenuKey } from 'common/models/commonModel';
import { GeneratePOPage } from 'app/pages/Franchisee/GeneratePOPage';
import { TrackPOPage } from 'app/pages/Franchisee/TrackPOPage';
import { ViewDeliveryHistoryPage } from 'app/pages/Franchisee/ViewDeliveryHistoryPage';
import { TrackStorePage } from 'app/pages/Franchisee/TrackStorePage';
import { StockReconciliationPage } from 'app/pages/Franchisee/StockReconciliationPage';
import { MonitorSalesPage } from 'app/pages/Franchisee/MonitorSalesPage';
import { ImproveQscPage } from 'app/pages/Franchisee/ImproveQscPage';
import { AnalyzeChannelsPage } from 'app/pages/Franchisee/AnalyzeChannelsPage';

export const CirLayout: FC = () => {
  const { segments } = useParams<{ segments: string | undefined }>();
  const { itemKey } = splitMenuPath(segments);

  const renderPage = () => {
    switch (itemKey) {
      case ESidebarMenuKey.GeneratePO: {
        return <GeneratePOPage />;
      }
      case ESidebarMenuKey.TrackPO: {
        return <TrackPOPage />;
      }
      case ESidebarMenuKey.ViewDeliveryHistory: {
        return <ViewDeliveryHistoryPage />;
      }
      case ESidebarMenuKey.TrackStoreRealTime: {
        return <TrackStorePage />;
      }
      case ESidebarMenuKey.StockReconciliation: {
        return <StockReconciliationPage />;
      }
      case ESidebarMenuKey.MonitorSales: {
        return <MonitorSalesPage />;
      }
      case ESidebarMenuKey.ImproveQsc: {
        return <ImproveQscPage />;
      }
      case ESidebarMenuKey.AnalyzeChannels: {
        return <AnalyzeChannelsPage />;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <Layout className="height-full">
      <Sidebar />

      {renderPage()}
    </Layout>
  );
};
